import React, { useMemo, useState, KeyboardEvent, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { PasscodeList } from '../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
// import LargeButton from '../../general-ui/button/large-button';
// import Checkbox from '../../general-ui/checkbox/checkbox';
import { EventsState } from '../../../store/types';
// import Modal from '../../general-ui/modal/modal';
// import TextInput, { Validation } from '../../general-ui/text-input/text';
// import PasscodeListMember from './passcode-list-member';
// import WaitingIndicator from "../../general-ui/waiting-indicator/waiting-indicator";
// import {
// 	getPasscodeListMembers,
// 	searchMembers,
// 	searchMemberCount,
// 	removeAllMembers,
// 	addSelectedMember,
// 	// removeSelectedMember
// } from '../../../store/actions/admin/passcode-list-members';
// import SearchBar from './search';
// import { AddNewMember } from '../../../connection/passcode-list-members';
// import { WorkingPasscodeList } from '../create/registration/passcode-list';
// import { GetDefaultPasscodeList } from '../../../store/utils/create-event';
// import { isValidEmail } from '../../../utils/utils';
// import {
// 	UpdateMaxUses,
// 	UpdateMasterPasscode,
// 	UploadMembers,
// 	DeleteMembers
// } from '../../../connection/passcode-lists';
// import { getPasscodeLists } from '../../../store/actions/admin/passcode-lists';
// import {
// 	GetUploadEndpoint,
// 	MakeItemPublic,
// 	UploadToS3,
// } from '../../../connection/uploads';
// import { v4 as uuid } from 'uuid';
// import Switch from '../../general-ui/switch/switch';
// import Paging from '../../general-ui/paging/paging';
import { addPaidListMember, getPaidListMembers, getPaidLists, searchPaidListMembers, setSelectedPaidList } from '../../../store/actions/admin/paid-lists-members';
import { IPaidList/* , TicketSetMember */ } from '../../../store/reducers/admin/paid-list-members';
import WaitingIndicator from '../../general-ui/waiting-indicator/waiting-indicator';
import SearchBar from './search';
import classNames from 'classnames';
import Paging from '../../general-ui/paging/paging';
import ModalComponent from '../../general-ui/modal/modal';
import TextInput from '../../general-ui/text-input/text';
import Switch from '../../general-ui/switch/switch';
import LargeButton from '../../general-ui/button/large-button';
import { UploadFile } from '../../../connection/uploads';
import { showAlert } from '../../general-ui/alert/alert-service';
import { AddPaidListMember, AddPaidListMemberMultiple } from '../../../connection/paid-lists';

// import { removeAll } from '../../../utils/event-emitter';


// interface Passcode {
// 	passcode: string;
// 	email: string;
// 	emailValidationState?: Validation;
// }

function formatNumber(num: number) {
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function PaidListTile(props: { list: IPaidList, onClick: () => void }): JSX.Element {
	const { list, onClick } = props;

	return (
		<div key={list.ticketingSet.uuid} className="passcode-tile">
			<div className="passcode-header">
				<button onClick={onClick} className="no-style no-padding">
					<div className="passcode-name">
						<h5>{list.ticketingSet.name}</h5>
					</div>
				</button>
				<button className="passcode-edit no-style" onClick={onClick}>
					<Icon
						name={ICONS.THREE_DOTS_VERTICAL}
						size={18}
						color={COLORS.DEFAULT_GRAY}
					/>
				</button>
			</div>
			<div className="event-title">
				<p>{list.eventName}</p>
			</div>
			<div className="passcode-members">
				<p>
					<strong>{formatNumber(list.members)}</strong> members
				</p>
			</div>

		</div>
	);
}

function formatCurrency(num: number, currency: string) {
	return (num * 0.01).toLocaleString(navigator.language, { style: 'currency', currency });
}

export default function PaidListEditor({ search }: { search: string }): JSX.Element {
	const {
		PaidListMemberReducer: {
			ticketSets,
			loadingTicketSets,
			ticketSetMembers,
			loadingSetMembers,
			selectedPaidList,
			ticketSetTotal
		},
		AuthReducer: { token, user },
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();
	const [addMembeModalOpen, setAddMemberModalOpen] = useState(false);
	const [searchValue, setSearchValue] = useState('');
	const [currentCardPage, setCurrentCardPage] = useState(1);
	const [currentListPage, setCurrentListPage] = useState(1);
	const [showUpload, setShowUpload] = useState(false);
	const [addUserEmail, setAddUserEmail] = useState('');
	const [addUserCsv, setAddUserCsv] = useState('');
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		dispatch(getPaidLists(token!, user!.active_channel));
	}, [token, user, dispatch]);

	const paidListArr = useMemo(() => {
		const tickets = [];
		const _search = search.toLowerCase().trim();
		for (const key in ticketSets) {
			if (search) {
				if (ticketSets[key].eventName.toLowerCase().trim().includes(_search) ||
					ticketSets[key].ticketingSet.name.toLowerCase().trim().includes(_search)
				) {
					tickets.push(ticketSets[key]);
				}
			} else {
				tickets.push(ticketSets[key]);
			}
		}

		return tickets;
	}, [ticketSets, search]);

	const selectList = useCallback((paid_list: IPaidList | null) => {
		return () => {
			dispatch(setSelectedPaidList(paid_list));
		};
	}, [dispatch]);

	useEffect(() => {
		if (selectedPaidList) {
			dispatch(getPaidListMembers(token!, selectedPaidList.ticketingSet.uuid!, (currentListPage - 1) * 50));
		}

		return () => {
			// when navigating away from this editor, set selectedPaidList to null
			if (selectedPaidList) {
				dispatch(setSelectedPaidList(null));
			}
		};
	}, [selectedPaidList, dispatch, token, currentListPage]);

	const handleSearchValue = useCallback(({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
		setSearchValue(value);

		if (!value) {
			dispatch(getPaidListMembers(token!, selectedPaidList!.ticketingSet.uuid!, (currentListPage - 1) * 50));
		}
	}, [dispatch, selectedPaidList, token, currentListPage]);

	const handleSearch = useCallback(() => {
		if (searchValue)
			dispatch(searchPaidListMembers(token!, selectedPaidList!.ticketingSet.uuid!, (currentListPage - 1) * 50, searchValue));
		else
			dispatch(getPaidListMembers(token!, selectedPaidList!.ticketingSet.uuid!, (currentListPage - 1) * 50));
	}, [dispatch, searchValue, selectedPaidList, token, currentListPage]);

	const handleKeyPress = useCallback(({ key }: KeyboardEvent) => {
		setCurrentListPage(1);
		switch (key) {
			case 'Enter':
				return handleSearch();
			case 'Escape': {
				setSearchValue('');
				dispatch(getPaidListMembers(token!, selectedPaidList!.ticketingSet.uuid!, (currentListPage - 1) * 50));
				return;
			}

			default:
				return;
		}
	}, [dispatch, handleSearch, selectedPaidList, token, currentListPage]);

	const closeModal = useCallback(() => {
		setAddMemberModalOpen(false);
	}, []);

	const handleAddMemberEmail = useCallback(({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
		setAddUserEmail(value);
	}, []);

	const handleFile = useCallback(async (file: File | FileList) => {
		if (file instanceof File) {
			setSaving(true);
			const uploaded = await UploadFile(user!, token!, file);
			setAddUserCsv(uploaded);
			setSaving(false);
		}
	}, [token, user]);

	const save = useCallback(async () => {
		try {
			setSaving(true);
			if (addUserEmail) {
				const newUser = await AddPaidListMember(token!, selectedPaidList!.ticketingSet.uuid!, addUserEmail);
				dispatch(addPaidListMember(newUser));
			}

			if (addUserCsv) {
				//out of sheer laziness, I don't want to re-query here and wait for this entire thing to insert in case it's huge
				//just let the user know they'll eventually be there
				AddPaidListMemberMultiple(token!, selectedPaidList!.ticketingSet.uuid!, addUserCsv);
				showAlert({
					message: "Users Uploaded",
					description: "Users should have access to the list shortly.",
					duration: 5000
				});
			}

			setAddUserCsv('');
			setAddUserEmail('');
			setSaving(false);
			setAddMemberModalOpen(false);
		} catch (e) {
			console.error(e);
			showAlert({
				message: "Unable to save",
				description: "We were unable to save the paid list. Please check your file and try again.",
				type: "error",
				duration: 10000
			});
		}
	}, [addUserCsv, addUserEmail, dispatch, selectedPaidList, token]);

	const cancel = useCallback(() => {
		setAddUserCsv('');
		setAddUserEmail('');
		setSaving(false);
		setAddMemberModalOpen(false);
	}, []);

	return (
		<>
			<div className={classNames({ "passcodelist-container": !selectedPaidList })}>
				{loadingTicketSets ? (
					<div className="loading-view">
						<WaitingIndicator />
					</div>
				) : (
					<>
						{selectedPaidList ? (
							<div className="passcode-wrapper paid-lists">
								<div className="list-header">
									<div className="header-left">
										<button
											onClick={selectList(null)}
											style={{ backgroundColor: 'transparent' }}
										>
											<Icon
												name={ICONS.ARROW_LEFT}
												size={16}
												color={COLORS.DEFAULT_GRAY}
											/>
										</button>
										<h2>{selectedPaidList.ticketingSet?.name}</h2>
									</div>
									<div className="header-right">
										<SearchBar
											style={{ marginBottom: 0 }}
											onChange={handleSearchValue}
											placeholder={'Search...'}
											onKeyPress={handleKeyPress}
											onSubmit={handleSearch}
										/>
										{/* <button
											className="list-settings"
											onClick={() => setSettingsModalOpen(true)}
										>
											<div
												style={{
													marginLeft: '8px',
													marginTop: '2px'
												}}>
												<Icon
													name={ICONS.SETTINGS_TRANSPARENT}
													size={12}
													color={COLORS.DEFAULT_GRAY}
												/>
											</div>
										</button> */}
										<button
											className="small add-passcode"
											onClick={() => setAddMemberModalOpen(true)}
										>
											<Icon
												name={ICONS.ADD}
												size={12}
												color={COLORS.BLACK}
											/>
											Add attendee
										</button>
										{/* <button
											className="small remove-passcodes"
											onClick={() => setDeletePasscodesModalOpen(true)}
											disabled={selectedMembers.length === 0}
										>
											<Icon
												name={ICONS.DELETE}
												size={12}
												color={COLORS.BLACK}
											/>
											Delete selected
										</button> */}
									</div>
								</div>
								<div className='list-subheader'>
									<p style={{ fontWeight: 'bold' }}>Sessions Accessed: {selectedPaidList.sessionNames.join(", ")}</p>
									{ticketSetTotal && (
										<h5>
											Total Sales: <span className="cyan">
												{formatCurrency(ticketSetTotal, selectedPaidList.ticketingSet.currency)}
											</span>
										</h5>
									)}
								</div>
								<div className="list-container paid-lists">
									<ul>
										<li className="list-item">
											<div className="header">
												<span>EMAIL ADDRESS</span>
											</div>
											<div className="header">
												<span>DATE PURCHASED</span>
											</div>
											<div className="header align-right">
												<span>AMOUNT PAID</span>
											</div>
										</li>

										{loadingSetMembers ? (
											<WaitingIndicator />
										) : ticketSetMembers.map((member, index) => (
											<li key={index} className="list-item">
												<div>{member.email}</div>
												<div>{new Date(member.created).toLocaleString()}</div>
												<div className="align-right">{member.amount ? formatCurrency(member.amount, member.currency) : 'VIP'}</div>
											</li>
										))}
										<div>
											{/* {uploadFile} */}
											{(selectedPaidList.members !== 0) &&
												<li className="list-pagination">
													<Paging
														page={currentListPage}
														setPage={setCurrentListPage}
														totalPages={Math.floor(selectedPaidList.members / 50)}
													/>
												</li>
											}
										</div>
									</ul>

									{!loadingSetMembers && ticketSetMembers.length === 0 && (
										<div className="empty">
											<h4>No users have paid for <span className="cyan">{selectedPaidList.ticketingSet.name}</span> yet.</h4>
										</div>
									)}
								</div>

							</div>
						) : (
							<>
								{paidListArr.length > 0 ? (
									<>
										{paidListArr.map((item, index) => {
											if (index >= ((currentCardPage - 1) * 16) && index <= (currentCardPage * 16)) {
												return (
													<PaidListTile key={item.ticketingSet.uuid} list={item} onClick={selectList(item)} />
												);
											}
										})}
									</>
								) : (
									<div className="empty-state">
										<h2>You have not set up any Ticket Sets</h2>
									</div>
								)}
							</>
						)}

					</>
				)}
				<ModalComponent
					open={addMembeModalOpen}
					onRequestClose={closeModal}
					cancellable={true}
					closeable={false}
					title={"Add Attendee"}
					footer={(
						<>
							<button onClick={cancel}>Cancel</button>
							<button className="primary" disabled={saving} onClick={save}>{saving ? <WaitingIndicator /> : "Save"}</button>
						</>
					)}
				>
					<div className="paid-list-modal">
						<TextInput
							email={true}
							placeholder={"Enter an email"}
							onChange={handleAddMemberEmail}
						/>

						<hr />

						<div className="field-group switch">
							<label>Upload list of users</label>
							<Switch
								on={showUpload}
								value="upload"
								onClick={() => setShowUpload(!showUpload)}
							/>
						</div>

						{showUpload && (
							<LargeButton
								onFile={handleFile}
								title={"Upload file"}
								subtitle={"or drag and drop here list in .csv format"}
								allowedFileTypes={["text/csv"]}
							/>
						)}
					</div>

				</ModalComponent>
			</div>
			{!selectedPaidList && (
				<div className="passcodelist-pagination">
					<Paging
						page={currentCardPage}
						setPage={setCurrentCardPage}
						totalPages={
							Math.floor(paidListArr?.length / 15) + 1
						}
					/>
				</div>
			)}
		</>
	);
}
